"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FactsFeaturesSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M8.6 5.4L6.8 5l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 5l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.8 1.7.8c.4.2.6 0 .6-.4l-.3-2 1.3-1.4c.3-.3.2-.6-.2-.7zM8.6 14.4L6.8 14l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 14l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.9 1.7.9c.4.2.6 0 .6-.5l-.3-1.9 1.3-1.4c.3-.3.2-.7-.2-.7zM8.6 23.4L6.8 23l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 23l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.9 1.7.9c.4.2.6 0 .6-.5l-.3-1.9 1.3-1.4c.3-.3.2-.7-.2-.7z"/><rect x="13" y="5" width="17" height="4" rx="2"/><rect x="13" y="14" width="17" height="4" rx="2"/><rect x="13" y="23" width="17" height="4" rx="2"/>';
var FactsFeaturesSVG = function FactsFeaturesSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FactsFeaturesSVG = FactsFeaturesSVG;
FactsFeaturesSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FactsFeaturesSVG);
exports.default = _default;